export default __webpack_public_path__ + "static/media/mobile-phone-group.63df0efe.svg";